const ReportTimeSelect = {
  YESTERDAY: 1,
  TODAY: 2,
  SEVEN_DAYS_AGO: 3,
  THIRTY_DAYS_AGO: 4,
  SELECT_MONTH: 5,
  SELECT_DATE: 6
}
export default ReportTimeSelect
